module.exports = __webpack_public_path__ + "img/salah.ee5a81f9.webp";